import dynamic from 'next/dynamic';

import type { BanFormProps } from '../../../contributor/Ban/BanForm';

export const BanAuthorOption = dynamic<BanFormProps>(() => import('./BanAuthorOptionDynamic'), {
  ssr: false,
});
